// extracted by mini-css-extract-plugin
module.exports = {"promo":"av7ry","content":"_20e3h","image":"OZLkG","heading":"lTG6I","title":"iIc9p","description":"DXwvN"};